import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import DraggableScroll from '../../draggableScroll';
import RichTextPreview from '../../richTextPreview';

const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    marginTop: spacing(4),
    [breakpoints.up('sm')]: {
      height: 'auto',
      maxHeight: '100%',
    },
  },
}));

const ReviewDescription = ({ survey, surveyStep }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <DraggableScroll showDesktopScrollbars>
        <RichTextPreview
          text={
            survey.questionnaire
              ? survey.questionnaire?.description
              : survey.attributes[surveyStep]?.visible_description
          }
        />
      </DraggableScroll>
    </div>
  );
};

ReviewDescription.propTypes = {
  survey: PropTypes.shape({}).isRequired,
  surveyStep: PropTypes.number.isRequired,
};

export default ReviewDescription;
